import { React, useState, useEffect } from 'react';
import exactMathNode from 'exact-math';
import { Link, useNavigate } from 'react-router-dom';
import Pagination from '../../components/Pagination';
import { Alert, ProjectService } from '../../services';
import 'react-loading-skeleton/dist/skeleton.css';
import { PlusIcon } from '../../components/icons/IconProvider';

import NoDataFound from '../../components/NoDataFound';
import { formatValue } from '../../utils/Helper';
import TableComponent from '../../components/TableComponent';
import StatusBadge from '../../components/StatusBadge';
import SortByFilter from '../../components/listing/SortByFilter';

import SearchInput from '../../components/SearchInput';
const ManageProjects = () => {
  const [projectList, setProjectList] = useState([]);
  const [page, setPage] = useState(1);
  const [, setTotalPages] = useState(1);
  const [perPage] = useState(10);
  const [isLoader, setLoader] = useState(false);

  const [isPagination, setPagination] = useState({
    totalPages: 10,
    currentPage: 1,
  });
  const [commonSearch, setCommonSearch] = useState('');
  const [, setSortBy] = useState('');

  const [filterData, setFilterData] = useState({
    perPage: perPage,
    page: 1,
    commonSearch: '',
    sortBy: 'new_to_old',
  });

  const navigate = useNavigate();

  const tableConfig = {
    columns: {
      project_name: {
        title: 'Project Name',
        render: (data) => {
          return (
            <span className=" inline-block-font-semibold">
              {data.name ? data.name : '--'}
            </span>
          );
        },
      },
      type: {
        title: 'Type',
        render: (data) => {
          return (
            <StatusBadge
              status={data?.investment_type === 'bond' ? 'Bond' : 'Equity'}
            />
          );
        },
      },
      asset_value: {
        title: 'Asset Value',
        render: (data) => {
          return (
            <span className=" inline-block-font-semibold">
              {data?.project_cost
                ? formatValue(data?.project_cost, {
                    decimalPlaces: 2,
                  })
                : '€0'}
            </span>
          );
        },
      },
      nominal_value: {
        title: 'Nominal Value',
        render: (data) => {
          return (
            <span className=" inline-block-font-semibold">
              {data?.nominal_value
                ? formatValue(data?.nominal_value, {
                    decimalPlaces: 2,
                  })
                : '0.00'}
            </span>
          );
        },
      },
      total_supply: {
        title: 'Total Minted',
        render: (data) => {
          return (
            <span className=" inline-block-font-semibold">
              {data?.total_minted || '0'}
            </span>
          );
        },
      },
      available_supply: {
        title: 'Available Supply',
        render: (data) => {
          // Calculate the available quantity
          const availableQuantity = exactMathNode.sub(
            data?.available_for_sale,
            Number(data?.sold_quantity),
          );
          return (
            <>
              <span className="inline-block font-semibold">
                {availableQuantity || '0'} of {data?.available_for_sale || '0'}
                {data?.lock_qty_total && data?.lock_qty_total > 0
                  ? ` (${data?.lock_qty_total} locked)`
                  : ''}{' '}
              </span>
            </>
          );
        },
      },
      status: {
        title: 'Status',
        render: (data) => {
          const availableQuantity = exactMathNode.sub(
            data?.available_for_sale,
            Number(data?.sold_quantity),
          );
          return (
            <>
              {availableQuantity === 0 ? (
                <span className="inline-block uppercase bg-[#f44336] text-white px-2 rounded-md pt-1 pb-[2px] font-semibold text-xs">
                  Sold out
                </span>
              ) : (
                <>
                  <StatusBadge
                    status={
                      data?.project_status === 0
                        ? 'project_draft'
                        : 'project_published'
                    }
                  />
                </>
              )}
            </>
          );
        },
      },
    },
    data: projectList,
  };

  useEffect(() => {
    (async () => {
      await getProjectList();
    })();
  }, [filterData]);

  const getProjectList = async () => {
    try {
      setLoader(true);
      let projectResponse = await ProjectService.getProjectList(
        filterData.perPage,
        filterData.page,
        filterData.commonSearch,
        filterData.sortBy,
      );
      if (projectResponse.status === 'failure') {
        setLoader(false);
        Alert.error(projectResponse.message);
        return false;
      }

      setPagination({
        totalPages: projectResponse.data.pagination.totalPages,
        currentPage: projectResponse.data.pagination.page,
      });
      setProjectList([...projectResponse.data.records]);
      setTotalPages(projectResponse.data.pagination.totalPages);
      setPage(projectResponse.data.pagination.page);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      Alert.error(error.message);
      return false;
    }
  };

  const searchData = () => {
    const commonSearch = document.getElementById('commonSearch').value;
    const sortBy = document.getElementById('sortBy').value;

    setFilterData({
      perPage: perPage,
      page: page,
      commonSearch: commonSearch,
      sortBy: sortBy,
    });
  };

  const handlePagination = (current) => {
    setPagination({ ...isPagination, currentPage: current });
    setFilterData({
      ...filterData,
      page: current,
    });
  };

  const resetFilter = () => {
    setSortBy('');
    setCommonSearch('');
    setFilterData({
      ...filterData,
      commonSearch: '',
      sortBy: ' ',
    });
  };
  //Sort Options
  const sortOptions = [
    { name: 'Old to New', value: 'old_to_new' },
    { name: 'High to Low Cost', value: 'high_to_low' },
    { name: 'Low to High Cost', value: 'low_to_high' },
  ];
  const projectRedirect = (project_id) => {
    navigate('/assets/view/' + project_id);
  };

  return (
    <div className="">
      <div className="grid grid-cols-2 mb-4">
        <h4 className="">Project Management</h4>
        <div className="flex justify-end items-center"></div>
      </div>

      <div className="w-full bg-brandGray px-4 md:px-5 py-4 rounded-xl">
        <div className="md:grid md:grid-cols-3 mb-2 md:mb-0 ">
          <div className="">
            <Link
              to="/assets/addedit"
              className="bg-brandBlue text-white w-full md:w-auto flex md:inline-flex items-center py-[9px] px-4 rounded-lg md:mr-3 mb-2 md:mb-0"
            >
              <PlusIcon />
              <span className="text-base leading-none">New Project</span>
            </Link>
          </div>
          <div className="md:flex items-center md:justify-end gap-3 md:col-span-2">
            <SortByFilter
              value={filterData.sortBy}
              dropdownList={sortOptions}
              filterData={filterData}
              setFilterData={setFilterData}
              setPage={setPage}
              fieldName="sortBy"
            />

            <div className="flex sm:inline-flex relative min-w-full md:min-w-[200px] mb-2 md:mb-0">
              <SearchInput
                name="commonSearch"
                value={commonSearch}
                id="commonSearch"
                placeholder="Search Keyword"
                onChange={(e) => {
                  setPage(1);
                  searchData();
                  setCommonSearch(e.target.value);
                }}
              />
            </div>

            <p
              className="text-blue-700 bg-blue-500 bg-opacity-5 rounded font-semibold text-sm inline-block cursor-pointer py-3 h-[42px] px-2 whitespace-nowrap"
              onClick={() => resetFilter()}
            >
              Clear filters
            </p>
          </div>
        </div>

        <div className="flex flex-col relative overflow-x-auto w-full">
          <TableComponent
            tableConfig={tableConfig}
            isListLoader={isLoader}
            isList={projectList}
            redirectTo={projectRedirect}
          />
        </div>
        {projectList && projectList.length > 0 && (
          <Pagination
            total={isPagination.totalPages}
            current={isPagination.currentPage}
            pagination={(crPage) => handlePagination(crPage)}
          />
        )}
        {projectList && projectList.length === 0 && isLoader === false && (
          <>
            <NoDataFound />
          </>
        )}
      </div>
    </div>
  );
};
export default ManageProjects;
